import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {useCallback} from 'react';

export const OFFCANVAS_DEFAULT_QUERY_PARAMETER = '1';

export const useOffcanvasOpenState = () => {
  const openedState = useOpenedStateManager('navigation');

  const handleOpen = useCallback(
    (props?: {parameter: string; replaceHistory: boolean}) => {
      openedState.open(props);
    },
    [],
  );

  const handleCancel = useCallback(() => {
    openedState.cancel();
  }, []);

  return {
    ...openedState,
    open: handleOpen,
    cancel: handleCancel,
  };
};
